import { Record } from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';
import _ from 'lodash';

const State = new Record({
    permissions: null,
    profiles: null,
    centers: null,
    fortalezaId: null,
    productCategories: null,
});

function getFortalezaId(centers) {
    let id = null;

    centers.forEach(function (item) {
        if (id !== null)
            return;

        let name = _.toLower(item.name);
        let idx = name.indexOf('fortaleza');

        if (idx > -1)
            id = item.id;
    });

    return id;
}

class UsersStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
                return state.clear();

            case ActionTypes.SELECT_PERMISSIONS_FINISH:
                return state.set('permissions', action.permissions);

            case ActionTypes.SELECT_PROFILES_FINISH:
                return state.set('profiles', action.profiles);

            case ActionTypes.SELECT_CENTERS_FINISH:
                return state
                    .set('centers', action.centers)
                    .set('fortalezaId', getFortalezaId(action.centers));

            case ActionTypes.SELECT_PRODUCT_CATEGORIES_FINISH:
                return state.set('productCategories', action.categories);

            default:
                return state;
        }
    }
}

export default new UsersStore();




// WEBPACK FOOTER //
// src/stores/UsersStore.js